import React, { useRef, useEffect, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { sequenceNumber } from "../../revampCRUD/ticketsNforms.crud";
import customToast from "../../components/common/basic/Toast.js";
import { uploadFile } from "../../revampCRUD/uploads.crud";
import { cleanForTinyMCE } from "../../Utils/cleanEmailHTML";

const EditorCustomTemplate = ({
	content,
	updateContent,
	placeholder,
	toolbar,
	heightCustom,
	formik,
	keyName,
	pasteImage,
	onPasteHandle,
	pasteAsPlainText = false,
	data,
	emailTitleToCheck,
	disabled = false,
	eventDetails,
	handleSeqDataFromChild,
	leadFollowupEmail = false,
}) => {
	const [sequenceNumbers, setSequenceNumbers] = useState({});
	const [loading, setLoading] = useState(false)
	const getSequenceNumber = async () => {
		setLoading(true)
		try {
			const res = await sequenceNumber(eventDetails.event_id);
			if (res.status === 200) {
				const seqNumDetailsFromApi = res.data.sequence_number_details;
				const seqDataForApi = [];
				const seqSetter = {};
				seqNumDetailsFromApi?.forEach(obj => {
					if (
						obj?.attached_tickets?.some(each =>
							formik.values?.applicable_ticket_ids
								?.map(each => Number(each))
								?.includes(Number(each))
						) ||
						obj?.attached_tickets?.includes(formik?.values?.ticket_id)
					) {
						const seqName = obj?.sequence_name?.toLowerCase().replace(" ", "_");
						seqSetter[obj?.sequence_name] = `{${seqName}}`;
						seqDataForApi.push({
							name: `{${seqName}}`,
							value: `{seq_${obj?.sequence_id.replaceAll("-", "_")}}`
						});
					}
				});
				setSequenceNumbers(seqSetter);

				handleSeqDataFromChild(seqDataForApi);
				setLoading(false)
			}
		} catch (err) {
			const errorMessage = err?.response?.data?.error || "Something went wrong";
			if (errorMessage?.data?.error) {
				customToast.error(errorMessage?.data?.error);
				setLoading(false)
			}
			return [];
		}
	};

	const editorRef = useRef(null);
	const placeHolderArr = {
		Name: "{name}",
		Email: "{email_id}",
		"Phone Number": "{phone_number}",
		"Booking Id": "{booking_id}",
		"Ticket Name": "{ticket_name}",
		"Event URL": "{event_url}",
		"Event Name": "{event_name}",
		"Organiser Email": "{organiser_email}",
		"Ticket URL": "{ticket_url}",
		...(leadFollowupEmail === false && { "QR Code": "{qrcode}" }),
		"Refund Amount": "{refund_amount}",
		"Booking Date": "{registered_at}",
		"Organizer Name": "{organiser_name}",
		"Event Date": "{event_date}",
		Venue: "{venue}",
		"Venue URL": "{venue_url}",
		"Payment Link": "{payment_link}",
	};

	useEffect(() => {
		if (
			placeholder === "Your Contact Attendee Mail text" ||
			placeholder == "Advanced Template"
		) {
			getSequenceNumber();
			if (placeholder == "Advanced Template") {
				placeHolderArr["Referral link"] = "{referral_link}";
			}
		}
	}, [formik?.values?.applicable_ticket_ids, formik?.values?.ticket_id]);

	if (placeholder == "Your Referral Email text here") {
		placeHolderArr["Referral link"] = "{referral_link}";
	} else if (placeholder == "Enter refund email description here") {
		placeHolderArr["Refund Amount"] = "{refund_amount}";
	}

	formik &&
		!formik?.values?.registration_status?.includes(3) &&
		formik?.values?.waitlist_status?.length === 0 &&
		(placeHolderArr["Ticket URL"] = "{ticket_url}");

	formik &&
		!formik?.values?.registration_status?.includes(2) &&
		!formik?.values?.registration_status?.includes(3) &&
		formik?.values?.waitlist_status?.length === 1 &&
		formik?.values?.waitlist_status?.includes(6) &&
		(placeHolderArr["Payment Link"] = "{payment_link}");

	keyName &&
		(keyName === "registration" ||
			keyName === "edit" ||
			keyName === "lead_follow_up" ||
			keyName === "refund" ||
			keyName === "forward") &&
		(placeHolderArr["Ticket URL"] = "{ticket_url}");

	const handleImageUpload = async file => {
		try {
			const downloadUrl = await uploadFile(file, 4);
			return downloadUrl;
		} catch (error) {
			console.error("Upload failed:", error);
			throw error;
		}
	};

	return heightCustom ? (
		<div key={JSON.stringify(sequenceNumbers)}>

			<Editor
				tinymceScriptSrc="/tinymce/tinymce.min.js"
				licenseKey="gpl"
				onInit={(_evt, editor) => (editorRef.current = editor)}
				value={(content ?? "")?.replaceAll(
					"${qrcode}",
					`https://files.konfhub.com/sample_qrcode.png`
				)}
				disabled={disabled || data?.campaign_status === 1}
				onPaste={() => {
					if (onPasteHandle && typeof onPasteHandle === "function") {
						onPasteHandle();
					}
				}}
				onEditorChange={e => {
					e = e.replaceAll(`<div style=margin-top="5%">`, "<div>");
					e =
						emailTitleToCheck && emailTitleToCheck.includes(keyName)
							? e.replaceAll("<p>", `<p style="margin:0px 0px"><br/>`)
							: e.replaceAll("<p>", `<p style="margin:0px 0px">`);
					e = e.replaceAll("white-space: pre-wrap", `white-space: initial`);
					e = e.replaceAll("white-space: pre-wrap;", `white-space: initial`);
					e = e.replaceAll("white-space: pre;", `white-space: initial`);
					const regex = /<img((?!width=)[^>])*?>/g;
					e = e.replace(regex, match => {
						if (!match.includes("width=")) {
							return match.replace(/<img/, '<img width="700"');
						}
						return match;
					});
					e = e?.replace(/<p[^>]*>\s*(<img[^>]+>)\s*<\/p>/g, '<div class="responsive-image-wrapper" >$1</div>');

					updateContent(e, formik);
				}}
				init={{
					placeholder: placeholder,
					autoresize_on_init: false,
					max_height: heightCustom,
					min_height: heightCustom,
					height: heightCustom,
					menubar: false,
					paste_data_images: pasteImage == false ? false : true,
					isSmartPasteEnabled: pasteImage == false ? false : true,
					forced_root_block_attrs: {
						style: "font-family: Hind, sans-serif; "
					},
					content_style: `
					body * { margin: 0; font-family: Hind, sans-serif; }
					.responsive-image-wrapper img { max-width: 100%; height: auto; display: block; margin: auto; }
`
,
					paste_enable_default_filters: false,
					plugins:
						"autoresize advlist autolink lists link image charmap preview anchor searchreplace visualblocks fullscreen insertdatetime table code help wordcount",
					paste_as_text: pasteAsPlainText,
					images_upload_handler: (blobInfo) =>
						new Promise(async (resolve, reject) => {
							try {
								const file = new File([blobInfo.blob()], blobInfo.filename(), {
									type: blobInfo.blob().type,
								});

								const downloadUrl = await handleImageUpload(file);

								const wrappedImage = `
										<div class="responsive-image-wrapper" style="max-width:100%; ">
										<img src="${downloadUrl}" alt="${blobInfo?.filename()}"
											style="max-width:100%; height:auto; display:block; " />
										</div>
									`;

								resolve({ html: wrappedImage });
							} catch (error) {
								console.error("Image upload failed:", error);
								reject("Image upload failed");
							}
						}),
					file_picker_callback: (callback, value, meta) => {
						if (meta.filetype === "image") {
							const input = document.createElement("input");
							input.setAttribute("type", "file");
							input.setAttribute("accept", "image/*");

							input.addEventListener("change", async () => {
								const file = input.files[0];
								try {
									const downloadUrl = await handleImageUpload(file);
									callback(downloadUrl, { alt: file.name, width: 700 });
								} catch (error) {
									console.error("Image upload failed:", error);
									callback("", { alt: "Image upload failed" });
								}
							});

							input.click();
						}
					},
					paste_preprocess: function (plugin, args) {
  						args.content = cleanForTinyMCE(args.content);
					},
					setup: function (ed) {
						window.tester = ed;
						ed.pasteAsPlainText = pasteAsPlainText;
						const fontOptions = [
							{ title: "Hind", value: "Hind, sans-serif" },
							{ title: "Arial", value: "Arial, sans-serif" },
							{ title: "Georgia", value: "Georgia, serif" },
							{ title: "Courier New", value: "'Courier New', monospace" },
							{ title: "Verdana", value: "Verdana, sans-serif" },
							{ title: "Times New Roman", value: "'Times New Roman', serif" }
						];

						const fontSizeOptions = [
							{ title: "Small", value: "12px" },
							{ title: "Normal", value: "14px" },
							{ title: "Large", value: "18px" },
							{ title: "Huge", value: "24px" }
						];

						// Custom: Font Family
						ed.ui.registry.addMenuButton("fontfamily", {
							text: "Font Family",
							fetch: callback => {
								const items = fontOptions.map(opt => ({
									type: "menuitem",
									text: opt.title,
									onAction: () => {
										ed.execCommand("fontName", false, opt.value);
										const selectedNode = ed.selection.getNode();
										ed.dom.setStyle(selectedNode, "font-family", opt.value);  // <- inline fallback
									}
								}));
								callback(items);
							}
						});


						// Custom: Font Size
						ed.ui.registry.addMenuButton("fontsize", {
							text: "Font Size",
							fetch: callback => {
								const items = fontSizeOptions.map(opt => ({
									type: "menuitem",
									text: opt.title,
									onAction: () => {
										ed.execCommand("fontSize", false, opt.value);
										// fallback inline styling
										const selectedNode = ed.selection.getNode();
										ed.dom.setStyle(selectedNode, 'font-size', opt.value);
									}
								}));
								callback(items);
							}
						});

						ed.ui.registry.addMenuButton("variables", {
							title: "Insert Variables",
							text: "Insert Variables",
							fetch: callback => {
								const variables = placeHolderArr;
								const items = [];

								Object.keys(variables).map(item => {
									items.push({
										type: "menuitem",
										text: item,
										onAction: () => {
											if (item === "QR Code") {
												ed.execCommand(
													"mceInsertContent",
													false,
													`<div style="text-align: center;" class="image">
														<img height="auto" src="https://files.konfhub.com/sample_qrcode.png" width="200">
													</div>`
												);
											} else {
												ed.execCommand(
													"mceInsertContent",
													false,
													`$${variables[item]}`
												);
											}
										}
									});
									return item;
								});
								if (Object.keys(sequenceNumbers).length > 0) {
									items.push({
										type: "nestedmenuitem",
										text: "Sequence Numbers",
										getSubmenuItems: () => {
											return Object.keys(sequenceNumbers).map(subItem => ({
												type: "menuitem",
												text: subItem,
												onAction: () => {
													ed.execCommand(
														"mceInsertContent",
														false,
														`$${sequenceNumbers[subItem]}`
													);
												}
											}));
										}
									});
								}

								callback(items);
							},
							onAction: function () { }
						});
					},
					toolbar: toolbar
				}}
			/>
		</div>
	) : (
		""
	);
};

export default EditorCustomTemplate;